import React from "react";
import PropTypes from "prop-types";
import "./load-more-button.m.css";

export const LoadMoreButton = ({ onClick }) => {
  return (
    <button onClick={onClick} styleName="load-more-button">
      Load More
    </button>
  );
};

LoadMoreButton.propTypes = {
  onClick: PropTypes.func
};
